// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_rw0","inner":"styles_inner__12NnV","right":"styles_right__-e4Yt","close":"styles_close__xDJqv","footer":"styles_footer__zB8l6"};